import LazySearchStore, { LazySearchScenarioStore } from './schema/LazySearchStore';
import { ObservableMap } from 'mobx';
import { createStore } from 'satcheljs';
import { PillSuggestion, SubstrateSearchSuggestionSegment } from 'owa-search-service';

export const createDefaultSearchStore = (): LazySearchScenarioStore => {
    return {
        alteredQuery: '',
        currentSearchQueryId: null,
        currentSuggestions: null,
        displayedQFRequestTime: null,
        flaggedTokens: [],
        isLastKeyPressedDeletion: false,
        isSuggestionsCalloutClickable: false,
        isSuggestionsDropdownVisible: false,
        isUsing3S: null,
        latestQFRequestId: null,
        latestQFTraceId: null,
        latestRenderedQFTraceId: null,
        latestTraceId: null,
        nextSearchQueryId: null,
        queryActionSource: null,
        queryAlterationType: null,
        recourseQuery: '',
        searchBoxWidth: null,
        searchSessionGuid: null,
        searchText: '',
        searchTextForSuggestion: '',
        selectedPillIndex: -1,
        selectedSuggestionIndex: -1,
        suggestedSearchTerm: '',
        suggestedSearchTermReferenceId: '',
        suggestionPillIds: [],
        suggestionPills: new ObservableMap<string, PillSuggestion>(),
        suggestionSegments: new ObservableMap<string, SubstrateSearchSuggestionSegment>(),
    };
};

export const searchStore: LazySearchStore = {
    scenarioStores: new ObservableMap<string, LazySearchScenarioStore>(),
};

export const getStore = createStore<LazySearchStore>('commonLazySearchStoreNext', searchStore);
export default getStore;
